module.exports = __webpack_public_path__ + "static/img/yt-logo-footer.479282d.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/yt-logo-footer.png
// module id = Kqru
// module chunks = 1 2 3 4 5 6